import { Divider } from "@mui/material";
import { useEffect, useMemo, useRef } from "react";
import { FaSpinner } from "react-icons/fa";

export const TaleUpload = ({
  title,
  extensions,
  selecteFilesText = "",
  dragNDropText = "",
  inputProps = {},
  onChange,
  files = [],
  width = "100%",
  height = 339,
  className = "",
  singleFile = false,
  removeFile,
  loading = false,
}) => {
  const ref = useRef();
  const allowedText = useMemo(
    () => ({
      images: "image/png, image/jpeg, image/jpg",
    }),
    []
  );
  useEffect(() => {
    if (!ref.current || !!files.length) return;
    if (!files.length) ref.current.value = "";
  }, [files.length]);

  return (
    <div
      className={`flex flex-col gap-1 ${className ?? ""}`}
      style={{
        width,
        height,
      }}
    >
      <div className="w-full flex justify-between">
        <span className="font-semibold text-sm text-black">{title}</span>
        <span className="font-normal text-sm text-[#666]">{extensions}</span>
      </div>
      <div
        className={`${
          singleFile && files.length
            ? "bg-white border border-[#ddd]"
            : "bg-[#cccccc40]"
        } flex items-center justify-center p-5 rounded-2xl overflow-hidden ${
          loading ? "" : "cursor-pointer"
        } relative`}
        style={{
          width,
          height,
        }}
        onClick={() => {
          if ((singleFile && files.length) || loading) return;
          ref.current.click();
        }}
      >
        {loading && (
          <div className="absolute z-10 top-0 left-0 size-full backdrop-blur-[2px] bg-slate-500/60 flex items-center justify-center">
            <FaSpinner className="animate-spin !size-10" color="lightblue" />
          </div>
        )}
        {singleFile && files.length ? (
          <div
            className={`absolute right-2 top-2 cursor-pointer`}
            onClick={(e) => {
              e.stopPropagation();
              removeFile(0);
            }}
          >
            <img src="/assets/close.svg" alt="Delete" />
          </div>
        ) : null}
        <input
          ref={ref}
          type={inputProps.type ?? "file"}
          style={{ display: "none" }}
          onChange={onChange}
          accept={allowedText[inputProps.accept ?? "images"]}
          {...inputProps}
        />
        {singleFile && files.length ? (
          <div
            className="max-w-full max-h-full"
            style={{
              maxWidth: "250px !important",
              maxHeight: "250px !important",
            }}
          >
            <img
              src={
                files[0] instanceof File || files[0] instanceof Blob
                  ? URL.createObjectURL(files[0])
                  : files[0]
              }
              alt={`File`}
              className="object-contain rounded-xl !h-[250px] !w-[400px]"
            />
          </div>
        ) : (
          <>
            <div
              className="rounded-2xl w-full h-full flex flex-col items-center justify-center"
              style={{
                border: "2px #CCCCCC dotted",
                textAlign: "center",
              }}
            >
              <img
                src={"/upload.png"}
                alt="Upload Icon"
                style={{
                  width: 60,
                  height: 60,
                  marginTop: 50,
                  cursor: "pointer",
                }}
              />
              <div
                style={{
                  color: "black",
                  fontSize: 14,
                  fontWeight: "600",
                  marginTop: 10,
                }}
              >
                {selecteFilesText || "Select files to upload"}
              </div>
              <div
                style={{
                  color: "#666666",
                  fontSize: 12,
                  fontWeight: "400",
                  marginTop: 5,
                }}
              >
                {dragNDropText || "or Drag and Drop, Copy and Paste Files"}
              </div>
              {files.length && !singleFile ? (
                <>
                  <Divider className="!mt-8 w-full !border-[1px] !border-dotted" />
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {files.map((file, index) => (
                      <div key={index} style={{ margin: 10 }}>
                        <img
                          src={
                            file instanceof File || file instanceof Blob
                              ? URL.createObjectURL(file)
                              : file
                          }
                          alt={`File ${index}`}
                          style={{
                            width: 150,
                            height: 110,
                            objectFit: "cover",
                            borderRadius: 10,
                          }}
                        />
                        <p
                          style={{ textAlign: "center" }}
                          className="font-medium text-sm"
                        >
                          {file.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              ) : null}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
